import axios from 'axios';

/*
*  This file contains all axios calls related to restore version on CB
*/

export const loadRestoredVersions = async (funnelId) => {
    const { data } = await axios.get(`/app/funnel/revisions?funnelId=${funnelId}`);

    return data;
};

export const restoreVersion = async (revisionId, draftXml, publishedXml) => {
    const payload = {
        draftXml,
        publishedXml,
    };

    const { data } = await axios.put(`/app/funnel/revert/${revisionId}`, payload);

    return data.xml;
};
